import { useEffect, useRef, useMemo } from 'react';

export const useBlurredImageLoader = (imageCount = 1) => {
    // Create refs arrays using useMemo to avoid recreating on every render
    const containerRefs = useMemo(
        () => Array.from({ length: imageCount }, () => ({ current: null })),
        [imageCount]
    );
    
    const imgRefs = useMemo(
        () => Array.from({ length: imageCount }, () => ({ current: null })),
        [imageCount]
    );

    useEffect(() => {
        const handleImageLoad = (imgElement, containerRef) => {
            if (!imgElement || !containerRef?.current) return;

            const loaded = () => {
                containerRef.current.classList.add('loaded');
            };

            if (imgElement.complete) {
                loaded();
            } else {
                imgElement.addEventListener('load', loaded);
                return () => imgElement.removeEventListener('load', loaded);
            }
        };

        const cleanupFunctions = [];

        imgRefs.forEach((imgRef, index) => {
            if (imgRef?.current && containerRefs[index]) {
                const cleanup = handleImageLoad(imgRef.current, containerRefs[index]);
                if (cleanup) cleanupFunctions.push(cleanup);
            }
        });

        return () => {
            cleanupFunctions.forEach(cleanup => cleanup && cleanup());
        };
    }, [containerRefs, imgRefs]);

    return {
        containerRefs,
        imgRefs
    };
};
export const useBlurredImageLoaderSingle = () => {
    const containerRef = useRef(null);
    const imgRef = useRef(null);

    useEffect(() => {
        const handleImageLoad = () => {
            if (!imgRef.current || !containerRef.current) return;

            const loaded = () => {
                containerRef.current.classList.add('loaded');
            };

            if (imgRef.current.complete) {
                loaded();
            } else {
                imgRef.current.addEventListener('load', loaded);
                return () => {
                    if (imgRef.current) {
                        imgRef.current.removeEventListener('load', loaded);
                    }
                };
            }
        };

        const cleanup = handleImageLoad();
        return () => cleanup && cleanup();
    }, []);

    return { containerRef, imgRef };
};